import React from "react";

const insuranceSyllabus = [
    {
        chapter: 1,
        title: "Risk Management",
        subTopics: [
            "Meaning of Risks",
            "Different Type of Risks",
            "Risk Classification",
            "Hazard",
            "Risk Analysis",
            "Risk Management Techniques",
        ],
        hours: 3,
    },
    {
        chapter: 2,
        title: "The Concept of Insurance and Its Evolution",
        subTopics: [
            "Concept of insurance",
            "History of Insurance in India",
            "Understand how insurance works",
            "Classes of Insurance",
        ],
        hours: 2,
    },
    {
        chapter: 3,
        title: "The Business of Insurance",
        subTopics: [
            "Management of Risk by Individuals",
            "Management of Risk by Insurers/Underwriters",
            "Fixation of premium",
            "Reinsurance",
        ],
        hours: 2,
    },
    {
        chapter: 4,
        title: "The Insurance Market",
        subTopics: [
            "Indian Insurance market",
            "Role of Insurance intermediaries",
            "Role of regulators",
            "Role of Specialists",
        ],
        hours: 4,
    },
    {
        chapter: 5,
        title: "Insurance Customers",
        subTopics: [
            "Insurance customers - Insured",
            "Different type of customers",
            "Customer satisfaction",
            "Ethical behaviour",
        ],
        hours: 3,
    },
    {
        chapter: 6,
        title: "The Insurance Contracts",
        subTopics: [
            "Insurance Contract",
            "Principle of Insurable Interest",
            "Principle of Indemnity",
            "Principle of Subrogation and Contribution",
            "Principle of Utmost Good Faith",
            "Proximate Cause",
        ],
        hours: 4,
    },
    {
        chapter: 7,
        title: "Insurance Terminology",
        subTopics: [
            "Terms related to Life and Non-Life insurance",
            "Terms related to Life Insurance",
            "Terms related to Non-Life insurance",
        ],
        hours: 2,
    },
    {
        chapter: 8,
        title: "Life Insurance Products",
        subTopics: [
            "Traditional products offered by Life Insurance Companies",
            "Features of linked policies",
            "Features of annuities and group policies",
        ],
        hours: 2,
    },
    {
        chapter: 9,
        title: "General Insurance Products",
        subTopics: [
            "Products offered by Non-life insurance Companies",
            "Features of Fire and Marine Insurance Products",
            "Features of Miscellaneous Products",
        ],
        hours: 3,
    },
];

export const PrincipleOfInsurance = () => {
    const totalHours = insuranceSyllabus.reduce((sum, item) => sum + item.hours, 0);

    return (
        <div className="container my-3 px-0"
            style={{
                maxHeight: 'fit-content'
            }}
        >
            <h5 className="text-center ">IC-01- Principles of Insurance</h5>
            <div className="table-responsive"
                style={{ height: '70vh' }}
            >
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-success text-center">
                        <tr>
                            <th className="bgblue">Chapter</th>
                            <th className="bgblue">Title</th>
                            <th className="bgblue">Sub-Topics</th>
                            <th className="bgblue">Training Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        {insuranceSyllabus.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center fw-bold">{item.chapter}</td>
                                <td>{item.title}</td>
                                <td>
                                    <ul className="mb-0 ps-3" style={{ listStylePosition: "inside" }}>
                                        {item.subTopics.map((topic, i) => (
                                            <li key={i}>{topic}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="text-center fw-semibold">{item.hours}</td>
                            </tr>
                        ))}
                        <tr className="table-secondary fw-bold">
                            <td colSpan={3} className="text-end">Total Training Hours =</td>
                            <td className="text-center">{totalHours}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
